import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function BookingCancel() {
  const { token } = useParams();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    api.post(`/bookings/cancel/${token}`).then(() => setStatus("done")).catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="container-vv py-24 text-center max-w-2xl" data-testid="cancel-page">
      {status === "pending" && <p className="text-[#292522]/60">Annullamento in corso…</p>}
      {status === "done" && (
        <>
          <div className="mx-auto h-16 w-16 rounded-full bg-[#FF6100] flex items-center justify-center text-white text-2xl">✓</div>
          <h1 className="mt-4 font-display font-medium text-4xl">Prenotazione annullata</h1>
          <p className="mt-3 text-[#292522]/70">La tua prenotazione è stata rimossa. Ci vediamo alla prossima occasione!</p>
          <Link to="/eventi" className="btn-primary mt-6 inline-flex">Guarda gli altri eventi</Link>
        </>
      )}
      {status === "error" && (
        <>
          <h1 className="font-display font-medium text-4xl">Link non valido</h1>
          <p className="mt-3 text-[#292522]/70">La prenotazione potrebbe essere già stata annullata o il link non essere corretto.</p>
          <Link to="/eventi" className="btn-primary mt-6 inline-flex">Torna agli eventi</Link>
        </>
      )}
    </div>
  );
}
